import React from "react";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import ResultsEmptyState from "./ResultsEmptyState";
import SearchDiscoveryIllustration from "./illustrations/SearchDiscoveryIllustration";
import SavedSearchIllustration from "./illustrations/SavedSearchIllustration";

export const SEARCH_EMPTY_NO_MATCH = "search-no-match";
export const SEARCH_EMPTY_ERROR = "search-error";
export const SAVED_SEARCH_EMPTY = "saved-search";

const SEARCH_PAGE_PATH = "/lists/companies/";

const COPY = {
  [SEARCH_EMPTY_NO_MATCH]: {
    title: "No companies found",
    description:
      "Try adjusting or removing some filters to broaden your search.",
  },
  [SEARCH_EMPTY_ERROR]: {
    title: "Results unavailable",
    description: "Retry the search or adjust your filters.",
  },
  [SAVED_SEARCH_EMPTY]: {
    title: "No results in this saved search",
    description:
      "The current filters don't match any companies. Adjust the filters to find more results.",
  },
};

/**
 * Context-aware empty state for Search and Saved Search result areas.
 */
export default function CompanyResultsEmptyState({
  variant = SEARCH_EMPTY_NO_MATCH,
  testId,
}) {
  const navigate = useNavigate();
  const copy = COPY[variant] || COPY[SEARCH_EMPTY_NO_MATCH];
  const isSaved = variant === SAVED_SEARCH_EMPTY;

  return (
    <ResultsEmptyState
      title={copy.title}
      description={copy.description}
      testId={testId || (isSaved ? "saved-search-empty-state" : "search-empty-state")}
      illustration={
        isSaved ? (
          <SavedSearchIllustration />
        ) : (
          <SearchDiscoveryIllustration />
        )
      }
      action={
        isSaved ? (
          <Button
            variant="contained"
            color="primary"
            onClick={() => navigate(SEARCH_PAGE_PATH)}
            data-testid="saved-search-empty-go-to-search"
            sx={{
              textTransform: "none",
              fontWeight: 700,
              fontSize: 14,
              letterSpacing: "-0.01em",
              px: 2.5,
              py: 1,
              borderRadius: 2,
            }}
          >
            Start filtering
          </Button>
        ) : null
      }
    />
  );
}
